import script from "./UpdateCategoriesStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateCategoriesStep.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateCategoriesStep.vue?vue&type=style&index=0&id=0d3ea360&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3ea360"]])

export default __exports__